import { ofType } from "redux-observable";
import { from } from "rxjs";
import { switchMap } from "rxjs/operators";
import { actionGameTrackingUpdateShop, actionGameTrackingUpdateUpdatePaymentShopClick, } from "../../actionGameTracking";
import { TypeActionGameTrackingShopOpenSource, } from "../actionGameTrackingShop";
import { IdGameTrackingShopState } from "../IdGameTrackingShopState";
import { IdShopOpenSource } from "../IdShopOpenSource";
export var epicGameTrackingShopClick = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionGameTrackingShopOpenSource.OpenSource), switchMap(function (action) {
        return from([
            actionGameTrackingUpdateUpdatePaymentShopClick(action.shopOpenSource),
            actionGameTrackingUpdateShop(IdGameTrackingShopState.SHOP_CLICK, IdShopOpenSource[action.shopOpenSource]),
        ]);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/shop/epics/epicGameTrackingShopClick.ts
// module id = 1879
// module chunks = 3